import { render, staticRenderFns } from "./MaterialListReplaceRaw.vue?vue&type=template&id=476a5feb&scoped=true"
import script from "./MaterialListReplaceRaw.vue?vue&type=script&lang=js"
export * from "./MaterialListReplaceRaw.vue?vue&type=script&lang=js"
import style0 from "./MaterialListReplaceRaw.vue?vue&type=style&index=0&id=476a5feb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a5feb",
  null
  
)

export default component.exports